import { Flex } from 'components/Flex';
import { useTranslation } from 'hooks/useTranslation';
import {
  FlexWrapper,
  SeniorityRankingContentWrapper,
  SeniorityRankingInfo,
  SeniorityRankingInfoColumn,
  SubHeader,
} from 'pages/SettingsPage/OrganizationSettingsPage/SeniorityRankingPage/SeniorityRankingPage.styled';
import { SettingsPageWrapper } from 'pages/SettingsPage/SettingsPage.styled';
import { H3, P } from 'components/Typography';
import { FC } from 'react';
import { useSeniorityRankingDataContext } from 'pages/SettingsPage/OrganizationSettingsPage/SeniorityRankingPage/SeniorityRankingPage.data.context';

export const SeniorityRankingTabReadView: FC = () => {
  const { t } = useTranslation();

  const { data } = useSeniorityRankingDataContext();

  return (
    <SeniorityRankingContentWrapper>
      <Flex margin="0 0 40px 0">
        <FlexWrapper height="100%" width="100%">
          <SettingsPageWrapper>
            <Flex flexDirection="column" gap="10px">
              <Flex padding="0 0 30px 0">
                <H3>{t('settings:SENIORITY_RANKING')}</H3>
              </Flex>
              <Flex padding="0 0 15px 0">
                <SubHeader>{t('settings:RANKING_CALCULATION_SELECTION')}</SubHeader>
              </Flex>
              <Flex padding="0 0 40px 0">
                <P>{t('settings:RANKING_CALCULATION_DESCRIPTION')}</P>
              </Flex>
              <SeniorityRankingInfo>
                <SeniorityRankingInfoColumn>
                  {t('location_settings:SENIORITY_RANKING_CALCULATION')}
                </SeniorityRankingInfoColumn>
                <SeniorityRankingInfoColumn>
                  {t(
                    `location_settings:SENIORITY_RANKING_IN_${data?.fetchCommunity?.organization?.seniorityMethod?.toUpperCase()}`,
                  )}
                </SeniorityRankingInfoColumn>
              </SeniorityRankingInfo>
            </Flex>
          </SettingsPageWrapper>
        </FlexWrapper>
      </Flex>
    </SeniorityRankingContentWrapper>
  );
};
